<template>
  <div class="info-section">
    <div class="info-section__header" v-if="$slots.header">
      <slot name="header"></slot>
      <hr>
    </div>
    <div class="info-section__content">
      <slot name="default">
        <div
          class="info-section__content-item"
          :class="item.classes"
          v-for="item in showedList"
          :key="item.fieldName"
        >
          <span class="title">{{item.title}}: </span>
          <slot :name="`item-${item.fieldName}`" :item="item">
            <span>{{filter(data, item)}}</span>
          </slot>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import mixin from './mixin'
export default {
  name: 'InfoSectionCard',
  mixins: [mixin],
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    showedList () {
      return this.preparedList
        .filter(({ fieldName }) => (!!this.data[fieldName] || this.data[fieldName] === false))
    }
  }
}
</script>
<style lang="stylus">
  @import "./styles.styl"
</style>
